import React, { Component } from "react";
import "./index.css";
import { BrowserRouter, withRouter } from "react-router-dom";
import Swiper from "react-tiga-swiper";
import "react-tiga-swiper/dist/index.css";
import classNames from "classnames";
import { BsyUtils } from "../../../utils/Utils";
import _ from "lodash";
class BsyDashCarouselMap extends Component {
  static defaultProps = {
    layout: "horizontal",
    todocount: 0,
  };

  constructor(props) {
    super(props);
    this.state = {
      mode: props.mode,
      layout: props.layout,
      designMode: props.designMode,
      showAction: false,
      todocount: 0,
      swiperWidth: "100%",
      carouselMap: props.carouselMap,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };
    this.noreferrer = React.createRef();
    this.swiperRef = React.createRef();
  }
  componentDidMount() {
    setTimeout(() => {
      var ret = BsyUtils.closestClass(this.noreferrer.current, "bsy-component");
      if (this.state.mode === "edit" && this.state.designMode === "phone") {
        this.setState({
          swiperWidth: window.$(ret).width() + "px",
          showAction: false,
        });
      } else {
        this.setState({
          swiperWidth: window.$(ret).width() + "px",
          showAction: true,
        });
      }
    }, 50);
  }
  toSettingCarouselMap = () => {
    this.props.emitSettingCarouselMap()
  }
  openImage = (val, item, key) => {
    let _this = this
    if (item.editModelLinkType && !_.isEmpty(item.editModelLinkFromData) && !item.eidtModelOpenLink) { // 内部表单-非空-新页面打开
      window.open(oppenFromData(item));
      return
    }
    if (item.editModelLinkType && !_.isEmpty(item.editModelLinkFromData) && item.eidtModelOpenLink) { // 内部表单-非空-当前页面打开
      window.location.href = oppenFromData(item)
      return
    }
    if (!item.editModelLinkType && !_.isEmpty(item.editModelink) && !item.eidtModelOpenLink) { // 外部链接-非空-新页面打开
      window.open(item.editModelink);
      return
    }
    if (!item.editModelLinkType && !_.isEmpty(item.editModelink) && item.eidtModelOpenLink) { // 外部链接-非空-当前页面打开
      window.location.href = item.editModelink;
      return
    }
    oppenFilePreview(key);
    function oppenFilePreview(key) {
      const { appId, entryId, carouselMap } = _this.props;

      let files = JSON.parse(JSON.stringify(carouselMap.files))
      files.forEach(element => {
        element.name = element.name || "默认图片"
        element.previewUrl = element.qnKey ? (element.previewUrl || BsyUtils.getfiledownloadURL(element, {})) : window.FX.CONST.QN_BUCKET.SITE + element.previewUrl
        element.previewURL = element.qnKey ? "" : element.previewUrl
        element.thumbUrl = element.qnKey ? (element.thumbUrl || BsyUtils.getfiledownloadURL(element, {})) : element.previewUrl
        element.mime = element.mim || "image/png"
      });
      new window.FX.FilePreview({
        widgetType: "image",
        files: files,
        appId: appId,
        hasDafaultFile: true,
        formId: entryId,
        currentItem: key,
        is_file_down: false
      });
    }
    function oppenFromData(item) {
      return (
        window.FX.CONST.QN_BUCKET.SITE + 'team/app/' +
        item.editModelLinkFromData.appid +
        "/" + (item.type || "form") + "/" +
        item.editModelLinkFromData.formid
      );
    }
  };
  swiperRefPrev = () => {
    const swiperInstance = this.swiperRef.current;
    swiperInstance?.prev();
  }
  swiperRefNext = () => {
    const swiperInstance = this.swiperRef.current;
    swiperInstance?.next();
  }
  render() {
    return (
      <>
        <div
          ref={this.noreferrer}
          className="carous-page"
          style={{ width: this.state.swiperWidth }}
        >
          {
            (this.state.carouselMap.files && this.state.carouselMap.files.length > 0) && <>{
              this.state.showAction ? (
                <><Swiper
                  {...this.state.swiperOptions}
                  autoPlay={
                    this.state.carouselMap.approveSwitch &&
                      this.state.mode !== "edit"
                      ? this.state.carouselMap.intervalBetweenRotations * 1000
                      : 99999999999
                  }
                  selectedIndex={0}
                  className="image-more-list"
                  showIndicators={this.state.carouselMap.files.length > 1}
                  showDots={this.state.carouselMap.files.length > 1}
                  dots={null}
                  ref={this.swiperRef}
                >
                  {this.state.carouselMap.files.map((item, key) => {
                    const url = BsyUtils.getfiledownloadURL(item, {});
                    return (
                      <div className="t-a-href" key={key}>
                        <div
                          className={classNames(
                            "pic",
                            this.state.carouselMap.layoutStyle
                          )}
                          style={{
                            backgroundImage: url ? "url(" + (item.previewUrl || url) + ")" : "",
                          }}
                          onClick={(val) => {
                            this.openImage(val, item, key);
                          }}
                        ></div>
                        <div
                          className={classNames(
                            "display-copy",
                            item.editModeCopywriting &&
                              item.editModeCopywriting !== ""
                              ? "has-bg"
                              : null
                          )}
                          onClick={(val) => {
                            this.openImage(val, item, key);
                          }}
                        >
                          {item.editModeCopywriting ? item.editModeCopywriting : ""}
                        </div>
                      </div>
                    )
                  })}
                </Swiper>

                  {
                    this.state.carouselMap.files && this.state.carouselMap.files.length >= 2 && <>
                      <div className="swiper-button-prev" onClick={this.swiperRefPrev}>
                        <i className="icon-bsy-left"></i>
                      </div>
                      <div className="swiper-button-next" onClick={this.swiperRefNext}>
                        <i className="icon-bsy-right"></i>
                      </div>
                    </>
                  }
                </>
              ) : (
                <>
                  {/* //手机端排序样子 */}
                  {
                    this.props.designMode === "phone" && this.props.mode === "edit" && this.state.carouselMap && this.state.carouselMap.files.length > 0 && <div className="iphone-sort" style={{
                      backgroundImage: this.state.carouselMap.files[0].previewUrl
                        ? "url(" + this.state.carouselMap.files[0].previewUrl + ")"
                        : window.FX.CONFIG.HOST.IMAGE_HOST + "/" + this.state.carouselMap.files[0].qnKey,
                    }}></div>
                  }
                </>

                // <div style={{ width: "100%", height: "100%", padding: "20px" }}>
                //   <div style={{ background: "rgba(0, 0, 0, 0.06)", height: "20px" }}></div>
                //   <div style={{ background: "rgba(0, 0, 0, 0.06)", height: "20px", marginTop: "20px", width: "50%" }}></div>
                //   <div style={{ background: "rgba(0, 0, 0, 0.06)", height: "20px", marginTop: "20px" }}></div>
                // </div>
              )
            }</>
          }
          {
            (!this.state.carouselMap.files || this.state.carouselMap.files.length === 0) &&
            <div className='notice-no-data'><span className='text'>暂未设置轮播图</span>
              {
                this.props.mode === "edit" && this.props.designMode === "computer" && <button onMouseDown={this.toSettingCarouselMap} className='setting-title'>设置</button>
              }
            </div>
          }

        </div>
      </>
    );
  }
}

export default BsyDashCarouselMap;
